<template>
  <v-overlay v-if="overlay" :value="value">
    <v-progress-circular indeterminate :size="size" :color="color" v-bind="{ ...$attrs }" />
  </v-overlay>
  <v-progress-circular v-else-if="value" indeterminate :size="size" :color="color" v-bind="{ ...$attrs }" />
</template>

<script>
export default {
  name: 'Loader.vue',

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    color: {
      type: String,
      default: 'primary'
    },
    overlay: Boolean,
    size: {
      type: Number,
      default: 64
    },
    value: {
      type: Boolean,
      default: true
    }
  }
}
</script>
